import styled, { css } from 'styled-components';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  heartColor?: 'white' | 'bgBlack' | undefined;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
}

export const LikeBtn = styled(Button)<IProps>`
  overflow: hidden;

  &.heartColor-black {
    &:not(.active) svg {
      path {
        stroke: #000;
      }
    }
  }

  ${props => {
    if (props.size === 'xs') {
      return css`
        &.active {
          > div {
            width: 13px;
            height: 13px;
          }
        }
      `;
    }

    if (props.size === 'sm') {
      return css`
        &.active {
          > div {
            width: 16px;
            height: 16px;
          }
        }
      `;
    }

    if (props.size === 'md') {
      return css`
        &.active {
          > div {
            width: 18px;
            height: 18px;
          }
        }
      `;
    }

    if (props.size === 'lg') {
      return css`
        svg {
          width: 20px;
          height: 20px;
        }

        &.active {
          > div {
            width: 20px;
            height: 20px;
          }

          svg {
            width: 20px;
            height: 20px;
          }
        }
      `;
    }

    if (props.size === 'xl') {
      return css`
        &.active {
          > div {
            width: 24px;
            height: 24px;
          }
        }
      `;
    }
    return null;
  }}

  &.heartColor-bgBlack {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 100%;
    width: 26px;
    height: 26px;
    transform: translateZ(0);
  }

  @media ${({ theme }) => theme.media.smMax} {
    ${props => {
      if (props.size === 'xs') {
        return css`
          &.active {
            > div {
              width: ${mixin.pxToVw('13')};
              height: ${mixin.pxToVw('13')};
            }
          }
        `;
      }

      if (props.size === 'sm') {
        return css`
          &.active {
            > div {
              width: ${mixin.pxToVw('16')};
              height: ${mixin.pxToVw('16')};
            }
          }
        `;
      }

      if (props.size === 'md') {
        return css`
          &.active {
            > div {
              width: ${mixin.pxToVw('18')};
              height: ${mixin.pxToVw('18')};
            }
          }
        `;
      }

      if (props.size === 'lg') {
        return css`
          svg {
            width: ${mixin.pxToVw('20')};
            height: ${mixin.pxToVw('20')};
          }

          &.active {
            > div {
              width: ${mixin.pxToVw('20')};
              height: ${mixin.pxToVw('20')};
            }

            svg {
              width: ${mixin.pxToVw('20')};
              height: ${mixin.pxToVw('20')};
            }
          }
        `;
      }

      if (props.size === 'xl') {
        return css`
          &.active {
            > div {
              width: ${mixin.pxToVw('24')};
              height: ${mixin.pxToVw('24')};
            }
          }
        `;
      }
      return null;
    }}

    &.heartColor-bgBlack {
      width: ${mixin.pxToVw('26')};
      height: ${mixin.pxToVw('26')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    &.heartColor-bgBlack {
      width: 36px;
      height: 36px;
    }
  }
`;
